export default __webpack_public_path__ + "static/media/Class-9-state-science.a46d9d1f.pdf";